export const CONFIG = {
  API_URL: import.meta.env.VITE_API_URL || '/api/v1',
  APP_NAME: import.meta.env.VITE_APP_NAME || 'OneckPass',
  APP_VERSION: import.meta.env.VITE_APP_VERSION || '1.0.0',

  // KDF defaults
  KDF: {
    ITERATIONS: Number(import.meta.env.VITE_KDF_ITERATIONS) || 3,
    MEMORY: Number(import.meta.env.VITE_KDF_MEMORY) || 65536,
    PARALLELISM: Number(import.meta.env.VITE_KDF_PARALLELISM) || 4,
  },

  // Timeouts
  CLIPBOARD_TIMEOUT: Number(import.meta.env.VITE_CLIPBOARD_TIMEOUT) || 30000,
  AUTO_LOCK_TIMEOUT: Number(import.meta.env.VITE_AUTO_LOCK_TIMEOUT) || 900000, // 15 min

  // Features
  FEATURES: {
    TWO_FACTOR: import.meta.env.VITE_ENABLE_2FA !== 'false',
    BREACH_CHECK: import.meta.env.VITE_ENABLE_BREACH_CHECK !== 'false',
  },
} as const;
